// extracted by mini-css-extract-plugin
module.exports = {"root":"DecisionList-root-ed4ee20024513c33238f841965b14c8b"};